import React, {Component} from "react";
import OrderPtm from "./VentanillaOrderPtmView";
import {VentanillaService} from "../../../service/ventanilla/VentanillaService";
import {Growl} from "primereact/growl";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {numberWithCommaText} from "../../../utils/formatters/Numbers";
import {calculateRateContainer, calculateRewardContainer, withoutComma} from "../../../utils/calculate/Amount";
import {strToDate} from "../../../utils/formatters/Date";
import {replaceAccents} from "../../../utils/formatters/Accent";

export default class VentanillaOrderPtmContainer extends Component {
    constructor(props) {
        super(props);

        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.ventanillaService = new VentanillaService();

        this.getOrderPtm = this.getOrderPtm.bind(this);
        this.loading = this.loading.bind(this);

        this.state = {
            today: new Date(),
            orderPtm: [this.getOrderPtm()],
            folio: this.props.location.state.folio,
            validDate: true,
            returnPath: this.props.location.state.returnPath,
            originalMaturity: this.props.location.state.maturity,
            originalAmount: this.props.location.state.amount,
            originalRate: this.props.location.state.rate,
            minReward: this.props.location.state.minReward,
            rate: this.props.location.state.rate,
        };

        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.saveOrder = this.saveOrder.bind(this);
        this.saveDataOrderLender = this.saveDataOrderLender.bind(this);

        this.state.orderPtm.folio = this.props.location.state.folio;
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    saveDataOrderLender(event) {
        let {name, value} = event.target;
        let orderPtm = this.state.orderPtm;
        let reward = 0;

        if (name === 'plazo' && this.state.originalMaturity < value) {
            value = this.state.originalMaturity;
        }

        if (name === 'cantidad' && this.state.originalAmount < withoutComma(value)) {
            value = this.state.originalAmount;
        }

        orderPtm[name] = value;

        reward = calculateRewardContainer(orderPtm.precio, orderPtm.cantidad, this.state.originalRate, orderPtm.plazo)

        if (withoutComma(reward) < withoutComma(this.state.minReward)) {
            orderPtm.tasa = calculateRateContainer(withoutComma(this.state.minReward), withoutComma(orderPtm.cantidad), withoutComma(orderPtm.precio), withoutComma(orderPtm.plazo));
        } else {
            orderPtm.tasa = this.state.originalRate;
        }

        this.setState({orderPtm: orderPtm,});
    }

    getOrderPtm() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }

        return this.ventanillaService.getOrderPtm(this.props.location.state.folio).then(
            order => {
                let data = order.payload[0];
                let valueDate = strToDate(data.fecValor);

                data.tasa = (data.tasa * 100.00).toFixed(2);
                data.sobreTasa = (data.sobreTasa * 100.00).toFixed(2);
                data.cantidadDisponible = data.cantidad;
                data.precio = valueDate > this.state.today ? "" : data.precio;

                this.setState({
                    orderPtm: data,
                    originalRate: data.tasa,
                    originalPrize: data.premio,
                })
            });
    }

    handleReturnButton() {
        this.props.history.push({
            pathname: this.state.returnPath,
        });
    }

    validateOrder() {
        let msgError = '';

        if (!this.state.validDate) {
            msgError = "El Plazo es incorrecto ya que el vencimiento no puede ser sábado, domingo o en día festivo";
        } else {
            let fields = [];

            if (
                this.state.orderPtm.cantidad === undefined ||
                this.state.orderPtm.cantidad === "" ||
                this.state.orderPtm.cantidad === "0" ||
                this.state.orderPtm.cantidad * 1 > this.state.orderPtm.cantidadDisponible

            ) {
                fields.push("Títulos");
            }

            if (
                this.state.orderPtm.plazo === undefined ||
                this.state.orderPtm.plazo === "" ||
                this.state.orderPtm.plazo === "0") {
                fields.push("Plazo");
            }

            if (fields.length > 0) {
                msgError = "Favor de revisar los siguientes campos: ";

                fields.map(field => {
                    msgError = msgError + field + ', ';
                    return '';
                });
            }
        }

        return msgError;
    }

    saveOrder() {
        let msg = this.validateOrder();
        if (msg !== '') {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: msg
            });
            return '';
        }

        this.ventanillaService.takeOrderLenderVentanilla(this.state.folio, this.state.orderPtm, this.state.originalMaturity, this.state.originalRate)
            .then(response => {
                if (response.error !== "") {
                    this.growl.show({
                        severity: 'error',
                        summary: 'Error.',
                        detail: replaceAccents(response.error)
                    });
                } else {
                    let message = {
                        severity: 'success',
                        summary: 'Éxito',
                        detail: replaceAccents(response.message),
                    };

                    this.props.history.push({
                        pathname: this.state.returnPath,
                        message: message,
                    });
                }
            });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        this.confMsg = <ConfirmationMessage nameButton="Guardar"
                                            ref={this.setConfirmationRef}
                                            legend={
                                                "¿Está seguro que desea agregar una postura con los siguientes valores?" +
                                                "|Cantidad = " + numberWithCommaText(this.state.orderPtm.cantidad) +
                                                "|Plazo = " + numberWithCommaText(this.state.orderPtm.plazo) +
                                                "|Tasa = " + numberWithCommaText(this.state.orderPtm.tasa) +
                                                "|Tipo Aforo = " + this.state.orderPtm.tipoAforo}
                                            action={this.saveOrder}/>;

        const {
            folio,
            orderPtm
        } = this.state;

        return <OrderPtm
            messagesGrowl={messagesGrowl}
            isLoading={this.state.isLoading}
            confMsg={this.confMsg}
            folio={folio}
            orderPtm={orderPtm}
            handleReturnButton={this.handleReturnButton}
            saveDataOrderLender={this.saveDataOrderLender}
        />
    }
}